export default __webpack_public_path__ + "static/ecom_3-57aee5f065964ae65143f16e9a7d1f2d.jpeg";